import {groupByUniqueKey} from '@benchling/js-utils';

import {
  ProcessGraphBuilderOutputNode,
  ProcessGraphBuilderRootNode,
  ProcessGraphBuilderTaskNode,
  SchemaMapperConfigWithMapperData,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';
import {getSchemaIdMappingToNode} from 'processes/graph-builder-processes/validation/ProcessGraphGetters';

export default function getSchemaOfItemsBeingRouted(
  upstreamNode: ProcessGraphBuilderTaskNode | ProcessGraphBuilderRootNode,
  downstreamNodes: Array<ProcessGraphBuilderTaskNode | ProcessGraphBuilderOutputNode>,
  schemaMapperConfigs: Array<SchemaMapperConfigWithMapperData>
): string | null {
  const mapperConfigByClientId = groupByUniqueKey(schemaMapperConfigs, ({clientId}) => clientId);

  const sourceSchemaIds = downstreamNodes.map((node) =>
    getSchemaIdMappingToNode(
      {
        taskSchemaId: node.taskSchemaId,
        id: node.clientId,
        nodeType: node.type,
        name: node.name,
      },
      {
        taskSchemaId: upstreamNode.taskSchemaId,
        id: upstreamNode.clientId,
        nodeType: upstreamNode.type,
        name: upstreamNode.name,
      },
      schemaMapperConfigs,
      mapperConfigByClientId
    )
  );
  if (sourceSchemaIds.includes(null)) {
    return null;
  }
  if (new Set(sourceSchemaIds).size !== 1) {
    return null;
  }
  return sourceSchemaIds[0];
}
